import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const modalsSlice = createSlice({
  name: 'modals',
  initialState: {
    modalParams: {} as Record<string, Record<string, any>>
  },
  reducers: {
    setModalParams(state, action: PayloadAction<{ id: string; params: Record<string, any> }>) {
      const { id, params } = action.payload
      const modal = state.modalParams[id]
      if (modal) {
        state.modalParams[id] = { ...modal, ...params }
      } else {
        state.modalParams[id] = params
      }
    }
  }
})

export const { setModalParams } = modalsSlice.actions
export default modalsSlice.reducer
